// extracted by mini-css-extract-plugin
export default {"container":"InputRadio_container__BYh6n"};